var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ShieldTickIcon, Strong, Trans, Typography, } from '@lucidlink/uicore';
import styles from './ZeroKnowledgeLabel.module.css';
export const ZeroKnowledgeLabel = () => (_jsxs(Box, { align: "center", className: styles.ZeroKnowledgeLabel, gap: "s", justify: "center", children: [_jsx(ShieldTickIcon, { size: "small" }), _jsx(Typography, { color: "inherit", "data-testid": "default-label", kind: "p-small", children: _jsx(Trans, { children: _jsx(Strong, { children: "Protected by zero knowledge" }) }) })] }));
_react_refresh_temp_1 = ZeroKnowledgeLabel;
$RefreshReg$(_react_refresh_temp_1, "ZeroKnowledgeLabel");
